/* eslint-disable camelcase */
import * as Yup from 'yup';

import { http } from 'lib/services/http';
import { platformAdminBaseUrl } from 'constants/apiUrls';
import { yupErrorHandler } from 'api/apiUtils';

const TEAMS_API_PATH = `${platformAdminBaseUrl}/teams`;

export const getTeams = () => {
  return http.get(`/iam/teams/summary`);
};

const modelCreate = Yup.object().shape({
  add_profile_ids: Yup.array().of(Yup.string()),
  department: Yup.object().shape({
    description: Yup.string().required(),
    name: Yup.string().required(),
  }),
});

export const createTeam = (payload) => {
  return modelCreate
    .validate(payload)
    .then(() => {
      return http.post(`${TEAMS_API_PATH}`, payload);
    })
    .catch((err) => {
      throw yupErrorHandler(err.errors);
    });
};

const modelGet = Yup.string().required();

export const getTeamDetails = (teamName: string) => {
  return modelGet
    .validate(teamName)
    .then(() => {
      return http.get(`${TEAMS_API_PATH}/retrieve?name=${teamName}`);
    })
    .catch((err) => {
      throw yupErrorHandler(err.errors);
    });
};
